import { render, staticRenderFns } from "./TotalRealPopup.vue?vue&type=template&id=a191a512"
import script from "./TotalRealPopup.vue?vue&type=script&lang=js"
export * from "./TotalRealPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports